@if (name && name.startsWith('lu-')) {
  <lucide-angular
    [name]="name.substring(3)"
    [size]="size"
    [color]="color"
    class="my-icon"></lucide-angular>
} @else {
  <ng-content></ng-content>
}
